import { LayoutsComponent } from './template1/layouts/layouts.component';

export const SettingsRouting: any = [];

SettingsRouting['template1'] = {
    path: '', component: LayoutsComponent,
    loadChildren: () => import('./template1/pages/pages.module').then(m => m.PagesModule)
  }